module.exports = __webpack_public_path__ + "static/media/browse-electric-used-vehicles.f5860b57.svg";